<template>
  <VRow justify="center">
    <VCol
      cols="12"
      md="8"
    >
      <VCard
        class="pa-6"
        dark
      >
        <VCardTitle class="text-h4 text-center">
          <VIcon
            size="36"
            class="mr-3"
            >ri-robot-2-line</VIcon
          >

          Automation Dashboard
        </VCardTitle>
        <VCardText class="text-center">
          <p class="text-h6">
            Welcome to the Automation Dashboard. Manage and trigger automation processes efficiently with just a few
            clicks.
          </p>
          <p>Use the tools below to monitor statistics, trigger automations, and view recent activities.</p>
        </VCardText>
      </VCard>
    </VCol>
  </VRow>
</template>
